import { AgencyBrandingPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard } from './../../shared/router/guards'

export default [
  // UAD-3667: visibility is gated by the white-label flag on the nav link
  // (requires.profile: ['is_white_label']); the page itself is scoped to the
  // user's own Elite Agency Team, so any authenticated user may load it.
  RouteFactory.create(AgencyBrandingPage, '/agency-branding', [new RequiresAuthGuard(true)], {
    name: 'Agency Branding',
  }),
]
